import React from 'react';

const PLACEHOLDER_IMAGE = '/achievements/placeholder/Placeholder.png';

const AchievementImage = ({ filename, alt, className, placeholderImage = PLACEHOLDER_IMAGE }) => {
  const imageUrl = `/achievements/${filename}`;

  const handleImageError = (e) => {
    if (e.target.src !== window.location.origin + placeholderImage) {
      e.target.onerror = null;
      e.target.src = placeholderImage;
    }
  };

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={className}
      onError={handleImageError}
      loading="lazy"
    />
  );
};

export default AchievementImage;